import { render, staticRenderFns } from "./AllRejectReasonsModal.vue?vue&type=template&id=26f715dd&scoped=true"
import script from "./AllRejectReasonsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllRejectReasonsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AllRejectReasonsModal.vue?vue&type=style&index=0&id=26f715dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f715dd",
  null
  
)

export default component.exports